import { ILead } from "../../../models/Lead";
import LeadContactDetails from "../../contacts/LeadContactDetails";
import Card from "../../shared/Card/Card";
import ClickToEdit from "../../shared/ClickToEdit";
import VehicleLocation from "../../vehicles/VehicleLocation";
import LeadContactAndVehicleDetails from "./LeadContactAndVehicleDetails";

export default function LeadContactAndVehicleTab({ lead }: { lead: ILead }) {
  return (
    <div className="[&>*]:shadow-none [&>*]:border-0 [&>*]:rounded-none">
      <ClickToEdit name="Contact & vehicle details">
        <Card title="Contact & vehicle pickup" bodyClassName="p-4" collapsible>
          <div className="grid grid-cols-1 gap-10 xl:grid-cols-2 xl:gap-8">
            <LeadContactDetails lead={lead} variant="embedded" />
            <VehicleLocation vehicle={lead.vehicle} variant="embedded" />
          </div>
        </Card>
      </ClickToEdit>
    </div>
  );
}
